import { render, staticRenderFns } from "./RenunciaView.html?vue&type=template&id=b1035380&external"
import script from "./RenunciaView.vue?vue&type=script&lang=js"
export * from "./RenunciaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports